import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { SeasonsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createSeason = (data): any => action(types.CREATE_TEAM_MEMBER_REQUESTED, data);

export const updateSeason = (data): any => action(types.UPDATE_TEAM_MEMBER_REQUESTED, data);

export const deleteSeason = (seasonId): any => action(types.DELETE_TEAM_MEMBER_REQUESTED, seasonId);

export const getSeason = (seasonId): any => action(types.GET_TEAM_MEMBER_REQUESTED, seasonId);

export const getAllSeasons = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_MEMBERS_REQUESTED, { pagination, compile });

export const getAllSeasonsSeasonView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  seasonCode = undefined,
): any => action(types.GET_ALL_TEAM_MEMBERS_REQUESTED, {
  pagination,
  compile,
  seasonView: true,
  teamCode,
  seasonCode,
});

export const selectSeason = (seasonId): any => action(types.SELECT_TEAM_MEMBER_REQUESTED, {
  currentSeasonId: seasonId,
});
export const clearSeasons = (): any => action(types.CLEAR_TEAM_MEMBERS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createSeasonPending: (payload): any => action(types.CREATE_TEAM_MEMBER_PENDING, payload),
  createSeasonSuccess: (response): any => action(types.CREATE_TEAM_MEMBER_SUCCESS, {
    seasonsById: response.entities.seasons,
    currentSeasonId: response.result,
  }),
  updateSeasonPending: (payload): any => action(types.UPDATE_TEAM_MEMBER_PENDING, payload),
  updateSeasonSuccess: (response): any => action(types.UPDATE_TEAM_MEMBER_SUCCESS, {
    seasonsById: response.entities.seasons,
    currentSeasonId: response.result,
  }),
  updateSeasonFailed: (error): any => action(types.UPDATE_TEAM_MEMBER_FAIL, { backendErrors: error }),
  deleteSeasonPending: (response): any => action(types.DELETE_TEAM_MEMBER_PENDING, response),
  deleteSeasonSuccess: (response): any => action(types.DELETE_TEAM_MEMBER_SUCCESS, {
    currentSeasonId: response,
  }),
  getSeasonPending: (): any => action(types.GET_TEAM_MEMBER_PENDING, {}),
  getSeasonSuccess: (response): any => action(types.GET_TEAM_MEMBER_SUCCESS, {
    seasonsById: response.entities.seasons,
    currentSeasonId: response.result,
  }),
  getSeasonFailed: (error): any => action(types.GET_TEAM_MEMBER_FAIL, { backendErrors: error }),
  deleteSeasonFailed: (error): any => action(types.DELETE_TEAM_MEMBER_FAIL, { backendErrors: error }),
  getAllSeasonsPending: (pagination): any => action(types.GET_ALL_TEAM_MEMBERS_PENDING, { pagination }),
  getAllSeasonsSuccess: (response, meta): any => action(types.GET_ALL_TEAM_MEMBERS_SUCCESS, {
    seasonsById: response.entities.seasons,
    seasonIds: response.result,
    meta,
  }),
  getAllSeasonsFailed: (error): any => action(types.GET_ALL_TEAM_MEMBERS_FAIL, { backendErrors: error }),
  createSeasonFailed: (error): any => action(types.CREATE_TEAM_MEMBER_FAIL, { backendErrors: error }),
};

export default null;
